/* Mobile-first sample collection controller.
 * Keeps sample cards, the sticky builder and the existing cart drawer in sync
 * with the box-as-properties cart model in sample-box.js.
 */
(function () {
  'use strict';

  if (window.rpSampleCollectionInitialised) return;
  window.rpSampleCollectionInitialised = true;

  var builder = document.querySelector('[data-sample-box-builder]');
  if (!builder && !document.body.classList.contains('figma-v2')) return;

  var isSampleCollection = builder && builder.getAttribute('data-sample-context') === 'collection';
  var state = null;
  var stateRequest = null;
  var initialised = false;
  var pageViewPublished = false;
  var renderQueued = false;
  var cfg = window.rpSampleBox || {};
  var perBox = parseInt(cfg.perBox, 10) || 5;
  var maxSamples = parseInt(cfg.maxSamples, 10) || 20;
  var priceCents = parseInt(cfg.priceCents, 10) || 1500;

  function api() { return window.RPSampleBox; }

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
      try { return privacy.analyticsProcessingAllowed(); } catch (error) { return false; }
    }
    return false;
  }

  function publish(eventName, data) {
    if (window.RPExperience) data = window.RPExperience.enrich(data);
    document.dispatchEvent(new CustomEvent(eventName, { detail: data }));
    if (!analyticsAllowed()) return;

    var analytics = window.Shopify && window.Shopify.analytics;
    if (analytics && typeof analytics.publish === 'function') {
      try {
        var result = analytics.publish(eventName, data);
        if (result && typeof result.catch === 'function') result.catch(function () {});
      } catch (error) {}
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, sample_box: data });
    }
  }

  function analyticsData(button, nextState) {
    return {
      product_id: button ? String(button.getAttribute('data-sample-product') || '') : '',
      variant_id: button ? String(button.getAttribute('data-sample-variant') || '') : '',
      sample_count: nextState.totalUnits,
      box_count: nextState.boxCount,
      value: (nextState.totalValueCents || (nextState.boxCount * priceCents)) / 100,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD'
    };
  }

  function money(cents) {
    var amount = cents / 100;
    return '$' + (amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2));
  }

  function selectedSample(variantId) {
    if (!state) return null;
    return state.selectedSamples.find(function (sample) {
      return String(sample.vid) === String(variantId);
    }) || null;
  }

  function setStatus(message) {
    var status = builder && builder.querySelector('[data-sample-builder-status]');
    if (status) status.textContent = message || '';
  }

  function setSampleLabel(button, label) {
    var labelNode = button.querySelector && button.querySelector('[data-sample-button-label]');
    (labelNode || button).textContent = label;
  }

  function renderCards() {
    if (!state) return;
    var atMaximum = state.totalUnits >= maxSamples;
    document.querySelectorAll('.js-sample-select[data-sample-variant]').forEach(function (button) {
      if (button.classList.contains('is-loading')) return;
      if (button.hasAttribute('data-sample-unavailable')) return;
      var selected = selectedSample(button.getAttribute('data-sample-variant'));
      var sampleTitle = button.getAttribute('data-sample-title') || 'Tile';
      var addLabel = button.getAttribute('data-sample-label-add') || 'Add sample';
      var addedLabel = button.getAttribute('data-sample-label-added') || 'Added ✓';
      var card = button.closest('[data-sample-tile-card]');
      var cardStatus = card && card.querySelector('[data-sample-card-status]');
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.disabled = !selected && atMaximum;
      setSampleLabel(button, selected ? addedLabel : (atMaximum ? 'Maximum reached' : addLabel));
      button.setAttribute('aria-label', selected
        ? 'Remove ' + sampleTitle + ' sample from box'
        : (atMaximum ? 'Maximum sample limit reached' : 'Add ' + sampleTitle + ' sample to box'));
      if (cardStatus && !atMaximum) cardStatus.textContent = '';
    });
  }

  function renderStudioSlots() {
    var slots = builder.querySelector('[data-studio-slots]');
    if (!slots) return;
    // Do not replace a focused removal control while an unrelated render occurs.
    var signature = JSON.stringify(state.selectedSamples);
    if (slots.getAttribute('data-state') === signature) return;
    var hadFocus = slots.contains(document.activeElement);
    var fragment = document.createDocumentFragment();
    state.selectedSamples.forEach(function (sample) {
      var slot = document.createElement('div');
      slot.className = 'v2-studio-slot';
      if (sample.img && /^(https?:)?\/\//.test(sample.img)) {
        var image = document.createElement('img');
        image.src = sample.img;
        image.alt = '';
        image.width = 80;
        image.height = 80;
        slot.appendChild(image);
      }
      var details = document.createElement('div');
      details.className = 'v2-studio-slot__details';
      var title = document.createElement('span');
      title.textContent = sample.name + (sample.qty > 1 ? ' × ' + sample.qty : '');
      details.appendChild(title);
      // Use the actual parent product type when its card is available; never invent it.
      var source = document.querySelector('[data-sample-tile-card] [data-sample-variant="' + sample.vid + '"]');
      var productType = source && source.getAttribute('data-sample-type');
      if (productType) {
        var type = document.createElement('span');
        type.className = 'v2-studio-slot__type';
        type.textContent = productType;
        details.appendChild(type);
      }
      slot.appendChild(details);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'js-sample-select';
      remove.textContent = '×';
      remove.setAttribute('data-sample-variant', sample.vid);
      remove.setAttribute('data-sample-title', sample.name);
      remove.setAttribute('data-sample-label-added', '×');
      remove.setAttribute('aria-pressed', 'true');
      remove.setAttribute('aria-label', 'Remove ' + sample.name + ' sample from box');
      slot.appendChild(remove);
      fragment.appendChild(slot);
    });
    var emptyCount = Math.max(perBox, state.boxCount * perBox) - state.totalUnits;
    for (var i = 0; i < emptyCount; i++) {
      var empty = document.createElement('button');
      empty.type = 'button';
      empty.className = 'v2-studio-slot v2-studio-slot--empty';
      empty.setAttribute('data-studio-add-slot', '');
      empty.textContent = 'Add a sample';
      fragment.appendChild(empty);
    }
    slots.replaceChildren(fragment);
    slots.setAttribute('data-state', signature);
    if (hadFocus) {
      var nextControl = slots.querySelector('button') || builder.querySelector('[data-sample-review]');
      if (nextControl) nextControl.focus();
    }
  }

  function renderBuilder() {
    if (!state || !builder) return;
    var count = state.totalUnits;
    var boxes = state.boxCount;
    var fill = state.activeBoxFill;
    var progress = builder.querySelector('[data-sample-builder-progress]');
    var summary = builder.querySelector('[data-sample-builder-summary]');
    var value = builder.querySelector('[data-sample-builder-value]');
    var segments = builder.querySelectorAll('[data-sample-builder-segments] span');

    var isStudio = builder.hasAttribute('data-sample-studio-builder');
    builder.hidden = !isStudio && count === 0;
    document.documentElement.classList.toggle('SampleBoxBuilderVisible', !isStudio && count > 0);
    if (isStudio) {
      builder.setAttribute('aria-busy', 'false');
      builder.setAttribute('data-sample-box-count', boxes);
      builder.querySelector('[data-sample-review]').disabled = count === 0;
      renderStudioSlots();
    }
    if (count === 0 && !isStudio) return;

    if (count === 0) {
      progress.textContent = '0 of ' + perBox + ' in Box 1';
    } else if (count === maxSamples) {
      progress.textContent = boxes + ' boxes full · Maximum reached';
    } else if (count % perBox === 0) {
      progress.textContent = 'Box ' + boxes + ' full';
    } else {
      progress.textContent = fill + ' of ' + perBox + ' in Box ' + boxes;
    }

    summary.textContent = count + (count === 1 ? ' sample' : ' samples') + ' · ' + boxes + (boxes === 1 ? ' box' : ' boxes');
    value.textContent = money(state.totalValueCents || (boxes * priceCents));
    Array.prototype.forEach.call(segments, function (segment, index) {
      segment.classList.toggle('is-active', index < fill);
    });
  }

  function render(nextState, message) {
    state = nextState;
    renderCards();
    renderBuilder();
    if (message) {
      setStatus(message);
    } else if (nextState.totalUnits >= maxSamples) {
      setStatus('Maximum reached. Your four sample boxes are full. Remove a sample before adding another.');
    }
  }

  function refreshState(message) {
    if (stateRequest) return stateRequest;
    stateRequest = api().getState().then(function (nextState) {
      render(nextState, message);
      return nextState;
    }).finally(function () { stateRequest = null; });
    return stateRequest;
  }

  function setButtonLoading(button, loading, label) {
    button.classList.toggle('is-loading', loading);
    button.disabled = loading;
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loading && label) setSampleLabel(button, label);
    if (!loading) button.removeAttribute('aria-busy');
  }

  function handleSampleToggle(button) {
    if (button.classList.contains('is-loading')) return;
    if (!state) {
      setButtonLoading(button, true, 'Loading…');
      refreshState().then(function () {
        setButtonLoading(button, false);
        handleSampleToggle(button);
      }).catch(function () {
        setButtonLoading(button, false);
        setSampleLabel(button, button.getAttribute('data-sample-label-add') || 'Add sample');
        var card = button.closest('[data-sample-tile-card]');
        var status = card && card.querySelector('[data-sample-card-status]');
        if (status) status.textContent = 'Your sample box could not be loaded. Please try again.';
      });
      return;
    }
    var selected = selectedSample(button.getAttribute('data-sample-variant'));
    var previousCount = state.totalUnits;
    var action;

    setButtonLoading(button, true, selected ? 'Removing…' : 'Adding…');
    if (selected) {
      action = api().removeSample(selected.index).then(function (ok) {
        if (!ok) throw new Error('remove');
        return refreshState('Sample removed from your box.');
      }).then(function (nextState) {
        publish('repubblica:sample_removed', analyticsData(button, nextState));
        return nextState;
      });
    } else {
      action = api().addSample({
        vid: button.getAttribute('data-sample-variant'),
        name: button.getAttribute('data-sample-title'),
        img: button.getAttribute('data-sample-image')
      }).then(function (result) {
        if (!result || !result.ok) {
          if (result && result.max) throw new Error('max');
          if (result && result.busy) throw new Error('busy');
          throw new Error('add');
        }
        return refreshState(result.already ? 'This sample is already in your box.' : 'Sample added to your box.').then(function (nextState) {
          if (!result.already) {
            publish('repubblica:sample_added', analyticsData(button, nextState));
            if (nextState.totalUnits > previousCount && nextState.totalUnits % perBox === 0) {
              publish('repubblica:sample_box_completed', analyticsData(button, nextState));
            }
          }
          return nextState;
        });
      });
    }

    action.catch(function (error) {
      var card = button.closest('[data-sample-tile-card]');
      var cardStatus = card && card.querySelector('[data-sample-card-status]');
      var message = error && error.message === 'max'
        ? 'Your four sample boxes are full. Remove a sample before adding another.'
        : 'We could not update your box. Please try again.';
      if (cardStatus) cardStatus.textContent = message;
      setStatus(message);
      return refreshState();
    }).finally(function () {
      setButtonLoading(button, false);
      renderCards();
    });
  }

  function openCartDrawer(trigger) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) {
      window.location.assign('/cart');
      return;
    }

    var opened = false;
    function show() {
      if (opened) return;
      opened = true;
      if (drawer.sidebarDrawer && typeof drawer.sidebarDrawer.show === 'function') {
        drawer.sidebarDrawer.show(trigger);
      } else {
        window.location.assign('/cart');
      }
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { onComplete: show }
    }));
    window.setTimeout(show, 2500);
  }

  function queueRenderCards() {
    if (renderQueued) return;
    renderQueued = true;
    window.requestAnimationFrame(function () {
      renderQueued = false;
      renderCards();
    });
  }

  function init() {
    if (initialised) return;
    if (!api() || typeof api().getState !== 'function') {
      window.addEventListener('load', init, { once: true });
      return;
    }
    initialised = true;

    document.addEventListener('click', function (event) {
      var sampleButton = event.target.closest('.js-sample-select');
      if (sampleButton) {
        event.preventDefault();
        handleSampleToggle(sampleButton);
        return;
      }

      var reviewButton = event.target.closest('[data-sample-review]');
      if (reviewButton && state) {
        publish('repubblica:sample_box_reviewed', analyticsData(null, state));
        if (!reviewButton.hasAttribute('data-v2-samples-open') || !window.RPV2Samples) openCartDrawer(reviewButton);
      }
    });

    document.addEventListener('repubblica:sample_box_changed', function (event) {
      if (event.detail) render(event.detail);
    });
    document.addEventListener('repubblica:sample_cards_loaded', function () { refreshState().catch(function () {}); });
    document.addEventListener('shopify:section:load', function () {
      builder = document.querySelector('[data-sample-box-builder]');
      refreshState().catch(function () {});
    });

    var products = document.querySelector('.FilterProducts');
    if (products && 'MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        var addedCards = mutations.some(function (mutation) {
          return Array.prototype.some.call(mutation.addedNodes, function (node) {
            return node.nodeType === 1 && (node.matches('[data-sample-tile-card]') || node.querySelector('[data-sample-tile-card]'));
          });
        });
        if (addedCards) queueRenderCards();
      }).observe(products, { childList: true, subtree: true });
    }

    refreshState().then(function (nextState) {
      if (!isSampleCollection || pageViewPublished) return;
      pageViewPublished = true;
      publish('repubblica:sample_page_viewed', analyticsData(null, nextState));
    }).catch(function () {
      setStatus('Your sample box could not be loaded. Please refresh the page.');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
